// store/tournamentSlice.ts
import { createSlice,type  PayloadAction } from '@reduxjs/toolkit';
import type { ICreateTournament } from '../../views/leaguesHome/tournaments/types/createtournament';

type TournamentState = {
  draft: Partial<ICreateTournament> | null;
};

const initialState: TournamentState = {
  draft: null,
};

const createTournamentSlice = createSlice({
  name: 'tournament',
  initialState,
  reducers: {
    saveTournamentDraft(state, action: PayloadAction<ICreateTournament>) {
      state.draft = action.payload;
    },
    clearTournamentDraft(state) {
      state.draft = null;
    },
  },
});

export const { saveTournamentDraft, clearTournamentDraft } = createTournamentSlice.actions;
export default createTournamentSlice.reducer;
